import { render, staticRenderFns } from "./OnlineWeekly.vue?vue&type=template&id=272e3f3f&lang=pug"
import script from "./OnlineWeekly.vue?vue&type=script&lang=js"
export * from "./OnlineWeekly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports